import { render } from "./NoteTypePriorityFields.vue?vue&type=template&id=5db3c1f0"
import script from "./NoteTypePriorityFields.vue?vue&type=script&lang=js"
export * from "./NoteTypePriorityFields.vue?vue&type=script&lang=js"

import "@/styles/NoteTypePriorityFields.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__